module.exports = __webpack_public_path__ + "static/media/texture.dfc588ef.png";